import * as React from 'react';
import EvaluateComponent from "../components/EvaluateComponent/EvaluateComponent";

import {connect} from "react-redux";
import {updateSource} from "../actions/literatureWizardActions";
import {shortlistAdd, shortlistRemove} from "../actions/literatureWizardActions";

import IShortlistable from "../interfaces/IShortlistable";
import IShortlistElement from "../interfaces/IShortlistElement";
import ISource from "../interfaces/ISource";

export interface IEvaluateProps {
    shortlist: IShortlistElement[],
    sources: ISource[],
    history: any,
    dispatchShortlistAdd: (elementType: IShortlistable, value: any) => any,
    dispatchShortlistRemove: (elementType: IShortlistable, value: any) => any,
    dispatchUpdateSource: (source: ISource) => any,
}

class EvaluateContainer extends React.PureComponent<IEvaluateProps> {
    public render() {
        return (
            <EvaluateComponent {...this.props}/>
        );
    }
}

const mapStateToProps = (store: any) => ({
    shortlist: store.literature.shortlist,
    sources: store.literature.sources
});

const mapDispatchToProps = {
    dispatchShortlistAdd: shortlistAdd,
    dispatchShortlistRemove: shortlistRemove,
    dispatchUpdateSource: updateSource,
};

export default connect(mapStateToProps, mapDispatchToProps)(EvaluateContainer);


// WEBPACK FOOTER //
// ./src/containers/EvaluateContainer.tsx